/*
 * @Author: wb丁鹏程 jacyding1996@163.com
 * @FilePath: /mall-fe/src/pages/shop/index/[shopSysNo].tsx
 * @Description: 移动端/PC端 店铺首页入口
 */
import ShopIndex from 'views/web/shop/ShopHome';
import { NextPageWithLayout } from 'pages/_app';
import { getShopInfoData, checkSupplierLimit, getShopInfo } from 'api/shop';
import { GetServerSideProps } from 'next';
import { MediaQueryContext } from 'libs/contexts';
import { useContext } from 'react';
import ShopMobileIndex from 'views/ShopIndex';
import { ShopInfo } from '@/comps/ShopInfoHead';
import { allSettled, isMobileMall } from 'libs/utils';
import { getDynamicEvaluation } from 'api/shop';
import { ProductListNetPriceContextProvider } from 'libs/contexts';
import { ShopType } from 'libs/enums';

export type ShopIndexPageData = {
  shopInfo: ShopInfo;
  supplierLimitEnable: boolean;
};

const ShopIndexPage: NextPageWithLayout = (props: any) => {
  // 是否是移动端  移动端走原有逻辑  PC走现有逻辑
  const { isMobile } = useContext(MediaQueryContext);
  return (
    <ProductListNetPriceContextProvider>
      {isMobile ? (
        <ShopMobileIndex
          shopInfo={props.shopInfo}
          supplierLimitEnable={props.supplierLimitEnable}
        />
      ) : (
        <ShopIndex shopData={props.shopData} />
      )}
    </ProductListNetPriceContextProvider>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const isMobile = isMobileMall(ctx.req);

  const props = {
    shopData: {},
    shopInfo: {
      sysNo: '',
      supplierSysNo: '',
      name: '',
      mainBusiness: '',
      serviceHotline: '',
      serviceHours: '',
      mallCategoryTreeDTO: {
        categories: [],
      },
      score: '',
    },
    supplierLimitEnable: false,
    evaluationData: {},
  };
  const serverHeaders = ctx.req.headers;
  const { shopSysNo } = ctx.query as { shopSysNo: string; preview };
  try {
    if (!isMobile) {
      const shopData: any = await getShopInfoData(shopSysNo, {
        serverSide: true,
        headers: serverHeaders,
      });
      const type = shopData?.data?.pageType;
      if (type === ShopType.PRO) {
        return {
          redirect: {
            permanent: false,
            basePath: false,
            destination: `/pages/shop/pro/index/${shopSysNo}`,
          },
        };
      }
      const evaluationRes = await getDynamicEvaluation({
        serverSide: true,
        headers: serverHeaders,
        json: {
          evaluateObjectType: 2,
          status: 1,
          evaluateObjectSysNo: shopData?.data?.supplierSysNo,
          pageNo: 1,
          pageSize: 10,
        },
      });
      if (shopData?.code === 200) {
        props.shopData = shopData.data;
        props.evaluationData = evaluationRes.data;
      }
    } else {
      const [shopInfoRes, checkSupplierLimitRes] = await allSettled([
        getShopInfo(shopSysNo, {
          serverSide: true,
          headers: serverHeaders,
        }),
        checkSupplierLimit(shopSysNo, {
          serverSide: true,
          headers: serverHeaders,
        }),
      ]);
      props.shopInfo = shopInfoRes.data?.data ?? props.shopInfo;
      props.supplierLimitEnable = checkSupplierLimitRes.data?.data ?? props.supplierLimitEnable;
    }
  } catch (error) {}

  return {
    props,
  };
};

export default ShopIndexPage;
